// extracted by mini-css-extract-plugin
export default {"container":"TwDh7b","content":"F8ZWiB","icon":"vlwQhB","title":"Bwguh7","quote":"LAMfgZ","picture":"PcJo7b"};